<template>
  <!-- same format with positions.vue -->
  <div>
    <v-btn @click="dialog = true"
      ><v-icon class="mr-2" color="red">mdi-hand-coin</v-icon> Benefits</v-btn
    >
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <ModalHeader
          title="Benefits"
          icon="mdi-window-maximize"
          @close="dialog = false"
        />
        <!-- add benefit card -->
        <v-card-text class="pa-4">
          <v-text-field
            label="Benefit Name"
            dense
            outlined
            v-model="benefit.name"
          ></v-text-field>
          <v-textarea
            label="Description"
            dense
            outlined
            v-model="benefit.description"
          ></v-textarea>
          <v-text-field
            label="Amount"
            dense
            outlined
            v-model="benefit.amount"
          ></v-text-field>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >

          <v-text-field
            label="Search"
            v-model="search"
            prepend-icon="mdi-magnify "
          ></v-text-field>
          <!-- benefits data table here -->
          <v-data-table
            :items="benefits"
            :headers="[
              { text: 'Actions', value: 'actions', sortable: false },
              { text: 'ID', value: 'id' },
              { text: 'Name', value: 'name' },
              { text: 'Description', value: 'description' },
              { text: 'Amount', value: 'amount' },
            ]"
            dense
          >
            <template v-slot:item.actions="{ item }">
              <div class="d-flex">
                <!-- edit -->

                <v-btn icon color="warning" @click="editBenefit(item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn icon color="red" @click="del(item)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- lazy components   -->

    <edit-benefit-modal
      v-if="editDialog"
      :item="editItem"
      @close="editDialog = false"
    ></edit-benefit-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    EditBenefitModal: () => import("./editBenefitModal.vue"),
  },
  data() {
    return {
      editDialog: false,
      editItem: {},
      dialog: false,
      search: "",
      benefit: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      benefits: "benefit/benefits",
    }),
  },
  methods: {
    ...mapActions({
      get_benefits: "benefit/get_benefits",
      add_benefit: "benefit/add_benefit",
      delete_benefit: "benefit/delete_benefit",
    }),
    editBenefit(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    async submit() {
      this.loading = true;
      try {
        this.add_benefit(this.benefit);
      } catch (error) {
        this.$alert({
          title: "Error",
          message: "Error adding benefit",
          color: "error",
          icon: "mdi-alert-circle",
        });
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async del(item) {
      if (
        await this.$confirm({
          title: "Delete Benefit",
          message: "Are you sure you want to delete this benefit?",
          color: "red",
          icon: "mdi-delete",
        })
      ) {
        try {
          await axios.delete(`benefit/${item.id}`);
          this.$alert({
            title: "Success",
            message: "Benefit deleted successfully",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.benefits = this.benefits.filter((b) => b.id !== item.id);
        } catch (error) {
          this.$alert({
            title: "Error",
            message: "Error deleting benefit",
            color: "error",
            icon: "mdi-alert-circle",
          });
          console.error(error);
        }
      }
    },
  },
  mounted() {
    if (this.benefits.length === 0) {
      this.get_benefits();
    }
  },
};
</script>

<style></style>
